import { Capacitor } from "@capacitor/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { PAGE_LOGIN } from "../../../../locales/pages/namespaces";
import {
    Link,
    Grid,
    Typography
} from "@mui/material";
import { getRouteUrl } from "../../../../helpers/getRouteUrl";

import { useHistory, Link as RouterLink } from 'react-router-dom'
import { ROUTE_PAGE_PRIVACY_POLICY, ROUTE_PAGE_TERMS_CONDITIONS } from "../../../../routers/routes";
import AuthBackground from "../../../../theme/mantis/assets/images/auth/authBackground";
import loginimg from '../../../../../src/assets/images/login-img.jpg';



// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Button } from '@mui/material';

// project import
import MainCard from "../../components/mainCard";
import LogoLogin from "../../components/logo/logoLoginNew";
 
import { useLocation } from "react-router";
import useUserAction from "../../../../hooks/user/useUserAction";


// ==============================|| AUTHENTICATION - CARD WRAPPER ||============================== //

const AuthCardWrapper = ({ children, ...other }) => {
	const theme = useTheme();
	const location = useLocation()
	const { t } = useTranslation(PAGE_LOGIN)

	const history = useHistory()

	
	return (

        <Grid container className='mt-5'>
            <AuthBackground />
            <Grid container spacing={2}>

                <Grid item xs={12} sm={7} md={7}>
                    <Grid sx={{
                        backgroundImage: `url(${loginimg})`, backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        width: '100%',
                        backgroundPosition: 'right',
                        height: '100vh',
                        minHeight: '100%',
                        height: {
                            xs: '272px',
                            sm: '100vh',
                            md: '100vh',
                        },
                        boxShadow: { xs: 'inset 0px -25px 22px #ffffff', sm: 'unset', md: 'unset' }
                    }}>
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={5} md={5} sx={{ display: 'flex', flexDirection: 'column', p: '32px 24px !important' }}>
                    <Grid sx={{ alignSelf: 'center', marginTop: 'auto' }}>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
							}}
						>
							<Box sx={{ m: '0 0 25px 0' }}>
								<LogoLogin  width={'5.958rem'} height={'5.257rem'} />
							</Box>
							<MainCard
								sx={{
									textAlign: 'center',
									maxWidth: { xs: '100%', lg: 400 },
									p: '0 24px',
								}}
								content={false}
								{...other}
								border={true}
								className='border-neutral-dark'
							>
								<Box>{children}</Box>
							</MainCard>

						</div>
                    </Grid>

                    <Grid sx={{ display: 'flex', alignSelf: 'flex-end', marginTop: 'auto', zIndex: '10', width: '100%', justifyContent: 'space-between', flexWrap: 'wrap' }} >
                        <Typography
                            variant="h5"
                            sx={{
                                width: { xs: '100%', sm: '100%', md: 'initial' },
                                textAlign: { xs: 'center', sm: 'center', md: 'left' },
                                marginTop: '30px',
                            }}
                        >
                            <Link
                                component={RouterLink}
                                className='color-default p-sm'
                                to={getRouteUrl(ROUTE_PAGE_PRIVACY_POLICY)}
								target={!Capacitor.isNativePlatform() && "_blank"}
                            >
                                {t('Privacy policy')}
                            </Link>
                        </Typography>
                        <Typography
                            variant="h5"
                            sx={{
                                width: { xs: '100%', sm: '100%', md: 'initial' },
                                textAlign: { xs: 'center', sm: 'center', md: 'right' },
                                marginTop: '30px',
                            }}
                        >
                            <Link
                                component={RouterLink}
                                className='color-default p-sm'
                                to={getRouteUrl(ROUTE_PAGE_TERMS_CONDITIONS)}
								target={!Capacitor.isNativePlatform() && "_blank"}
                            >
                                {t('Terms & Conditions')}
                            </Link>
                        </Typography>
                    </Grid>

                </Grid>
            </Grid>
        </Grid>
	);
};

export default AuthCardWrapper;